import { render, staticRenderFns } from "./MailsSettings.vue?vue&type=template&id=39d7ded7"
import script from "./MailsSettings.vue?vue&type=script&lang=ts"
export * from "./MailsSettings.vue?vue&type=script&lang=ts"
import style0 from "./MailsSettings.vue?vue&type=style&index=0&id=39d7ded7&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d7ded7')) {
      api.createRecord('39d7ded7', component.options)
    } else {
      api.reload('39d7ded7', component.options)
    }
    module.hot.accept("./MailsSettings.vue?vue&type=template&id=39d7ded7", function () {
      api.rerender('39d7ded7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/MailsSettings.vue"
export default component.exports